import { gql } from "config/graphql";
import { IUser } from "config/types";
import { CONSTELLATION_FIELDS } from "gql/fragments";
import { gqlQuery } from "store/apollo";

const NotificationsChannel = {
  email: "email",
  push: "push",
  sms: "sms",
} as const;
type NotificationsChannel = (typeof NotificationsChannel)[keyof typeof NotificationsChannel];

interface IUserOtpNotification {
  channel: NotificationsChannel;
  metadata: Record<string, unknown>;
  createdAt: string;
}

interface IUserOtpNotifications {
  data: {
    user: {
      notifications: IUserOtpNotification[];
    };
  };
}

interface IFetchCurrentUserResponse {
  data: {
    me: IUser;
  };
}

export const fetchCurrentUserQuery = (): Promise<IFetchCurrentUserResponse> => {
  const query = gql`
    ${CONSTELLATION_FIELDS}
    query currentUser {
      me {
        id
        age
        birthdate
        age
        status
        createdAt
        activeConstellations {
          ...ConstellationFields
        }
      }
    }
  `;

  return gqlQuery<IFetchCurrentUserResponse["data"]>({ query });
};

export const fetchUserOtpNotificationsQuery = (
  userId: string,
  authorizationToken: string
): Promise<IUserOtpNotifications> => {
  const query = gql`
    query UserOtpNotifications($userId: ID!) {
      user(id: $userId) {
        notifications {
          channel
          metadata
          createdAt
        }
      }
    }
  `;

  return gqlQuery<IUserOtpNotifications["data"]>({
    context: {
      headers: {
        authorization: `Bearer ${authorizationToken}`,
      },
    },
    variables: { userId },
    query,
  });
};
